module.exports = __webpack_public_path__ + "assets/img/three.c3b64c55.png";